import * as React from "react";
import { Frame } from "../frame/index.js";
import { Footer } from "./Footer.jsx";
import { SidebarLoader } from "./SidebarLoader.jsx";
import { Main } from "./Main.jsx";
//import * as cls from "./StudioFrame.module.scss";
export { StudioFrame };
/**
 * Фрейм страницы личной студии, включающий панель навигации,
 * боковую панель, обрамление основного содержимого
 * и подвал с юридической информацией.
 * @summary Фрейм страницы Личной студии.
 * @param {Object} props - Атрибуты элемента.
 * @param {JSX.Element} props.children -
 * Основное содержимое страницы.
 * @returns {JSX.Element} Элемент JSX.
 * @example
 * import {StudioFrame} from "../personal-studio-components/studio/index.jsx";
 * <StudioFrame>Содержимое</StudioFrame>
 * @see {@link ../frame/Action.jsx}, {@link ../frame/Logo.jsx}
 * @author Алексей Васьковский <avaskovskiy@umney.ru>
 */
function StudioFrame({ children, handleSignOut }) {
  return (
    <Frame>
      <SidebarLoader onSignOut={handleSignOut}>
        <Main>{children}</Main>
        <Footer />
      </SidebarLoader>
    </Frame>
  );
}
